import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './ForgotPassword.css';

const PatientForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const response = await api.post('/auth/patient/forgot-password', { email });
      setMessage(response.data.message);
    } catch (error) {
      setError(error.response?.data?.error || 'Something went wrong.');
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="auth-container">
        <h2>Forgot Password (Patient)</h2>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Submit</button>
        </form>
        <p>
          <button onClick={() => navigate('/login?type=patient')} className="back-link">
            Back to Login
          </button>
        </p>
      </div>
    </div>
  );
};

export default PatientForgotPassword;